// @ts-nocheck
/* eslint-disable */

  /**
  * Do not change! File was auto generate. 
  *
  */
  
import React from 'react';

import { ReactComponent as ChpokifyIconComponent} from './ChpokifyIcon.svg';

import Icon, { TIconProps } from '../Icon';

export const IconChpokifyIcon = React.forwardRef<any, TIconProps>((props, ref) => (
  <Icon
    ref={ref}
    {...props}
  >
    <ChpokifyIconComponent/>
  </Icon>
));
